import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getVersionInfoList(pageNum,pageSize) {
  return request({
    url: '/version/getVersionInfoList',
    params: {
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function updateVersionInfo(version) {
  return requestMsg({
    url: '/version/updateVersionInfo',
    data: JSON.stringify(version),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}

export function getVersionInfoById(id) {
  return requestMsg({
    url: '/version/getVersionInfoById',
    params: {
      id: id,
    }
  })
}

export function delByVersionInfoId(id) {
  return requestMsg({
    url: '/version/delByVersionInfoId',
    params: {
      id: id,
    }
  })
}
